/** Browser `fetch` does not apply Next `basePath`; align with `next.config` via `NEXT_PUBLIC_APP_BASE_PATH`. */
export function withAppBasePath(path: string): string {
  const base = (process.env.NEXT_PUBLIC_APP_BASE_PATH || "").replace(/\/$/, "");
  const p = path.startsWith("/") ? path : `/${path}`;
  return base ? `${base}${p}` : p;
}
